import { APIResponse, OrganisationDocument, UserAPIPathGenerator, UserDocument } from "server-model";
import { UserConnector } from "../data-connectors";
import { AppServerConnector } from "./app-server.connector";

export class AppServerUserConnector extends AppServerConnector implements UserConnector {
    async getUser(userId: string): Promise<APIResponse> {
        try {
            const response = await this.axios.get(
                UserAPIPathGenerator.details(userId),
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("User not found")
            }
        } catch (error) {
            console.log(error)
            throw error;
        }
    }
    async createUser(userDocument: UserDocument): Promise<APIResponse> {
        try {
            const response = await this.axios.post(
                UserAPIPathGenerator.create(),
                { userDocument: this.toPlain(userDocument) },
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to create user")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async updateUser(userId: string, userDocument: UserDocument): Promise<APIResponse> {
        try {
            const response = await this.axios.put(
                UserAPIPathGenerator.update(userId),
                { userDocument: this.toPlain(userDocument) },
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to update user")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async deleteUser(userId: string): Promise<APIResponse> {
        try {
            const response = await this.axios.delete(
                UserAPIPathGenerator.delete(userId),
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to delete user")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async getUserOrganisations(userId: string): Promise<APIResponse> {
        try {
            const response = await this.axios.get(
                UserAPIPathGenerator.listOrganisations(userId),
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to fetch user organisations")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async getOrganisationUser(userId: string, organisationId: string): Promise<APIResponse> {
        try {
            const response = await this.axios.get(
                UserAPIPathGenerator.organisationUser(userId, organisationId),
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to fetch user")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

}